// extracted by mini-css-extract-plugin
export default {"link":"eJzu5oeHfTgrrBD8pRne"};